class CacheManager {
  constructor() {
    this.memoryCache = new Map();
    this.ttl = 0//5 * 60 * 1000; // 5 minutes
  }

  async get(method, url) {
    const cacheKey = this.generateCacheKey(method, url);
  
    // Check memory
    const memItem = this.memoryCache.get(cacheKey);
    if (memItem && Date.now() < memItem.expires) return memItem.data;
  
    // Check localStorage
    const stored = localStorage.getItem(this.storageKey);
    if (stored) {
      const parsed = JSON.parse(stored)[cacheKey];
      if (parsed && Date.now() < parsed.expires) {
        this.memoryCache.set(cacheKey, parsed);
        return parsed.data;
      }
    }
  
    return null;
  }
  
  async set(method, url, data) {
    const cacheKey = this.generateCacheKey(method, url);
    const expires = Date.now() + this.ttl;
  
    this.memoryCache.set(cacheKey, { data, expires });
  
    const cache = JSON.parse(localStorage.getItem(this.storageKey) || '{}');
    cache[cacheKey] = { data, expires };
    localStorage.setItem(this.storageKey, JSON.stringify(cache));
  }
  
  generateCacheKey(method, url) {
    return `${method}:${url}`;
  }
  
  clear() {
    this.memoryCache.clear();
    localStorage.removeItem(this.storageKey);
  }

  delete(key) {
    this.memoryCache.delete(key);

    const cache = JSON.parse(localStorage.getItem(this.storageKey) || '{}');
    delete cache[key];
    localStorage.setItem(this.storageKey, JSON.stringify(cache));
  }
}

export const cacheManager = new CacheManager();
